import Text from '@atoms/Text/Text';
import { IToggle } from '@models/IToggle';
import classNames from 'classnames';

const Toggle = ({ options, value, label, onChange }: IToggle) => (
  <div className="tw-flex tw-items-center tw-gap-2 md:tw-mr-4">
    {label && (
      <Text variant="label-12" className=" tw-text-grey-80">
        {label}
      </Text>
    )}
    <div className="tw-flex tw-rounded tw-border tw-border-grey-80">
      {options.map(({ label, value: opt }, index) => {
        const isActive = value === opt;
        const buttonClasses = classNames('tw-px-3 tw-py-1 tw-text-sm', {
          'tw-bg-grey-20': isActive,
          'tw-rounded-l tw-border-r': index === 0,
          'tw-rounded-r': index === options.length - 1,
        });
        return (
          <button
            key={opt}
            className={buttonClasses}
            onClick={() => onChange(opt)}
            type="button"
          >
            {label}
          </button>
        );
      })}
    </div>
  </div>
);

export default Toggle;
